import { api } from './client'

export function getSecuritySettings() {
  return api.get('/security/settings').then((r) => r.data)
}

export function updateSecuritySettings(body) {
  return api.put('/security/settings', body).then((r) => r.data)
}
